///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. Interface
        a. init
        b. showMemberLookupModal
        c. clearMember
    
    2. Helpers
        a. refresh
        b. individualAndFacilityWatchAction

    3. Property Accessors            
        a. getData
        b. setData
  
*/

(function () {
    'use strict';

    angular
        .module('app.courseHandicap')
        .component('sc3CourseHandicapHeader', {
            templateUrl: 'app/course-handicap/course-handicap-header.component.html',
            controller: CourseHandicapHeaderComponent,
            bindings: { model: '<' }
        });

    var noop = angular.noop,
        forEach = angular.forEach;

    CourseHandicapHeaderComponent.$inject = ['$scope', 'Course', 'alert', 'memberLookupModal', 'courseHandicap_resources'];
    function CourseHandicapHeaderComponent($scope, Course, alert, memberLookupModal, resources) {
        // Variables
        var ctrl = this;

        // Properties
        ctrl.facility = null;
        ctrl.individualId = null;
        ctrl.handicapPercent = null;
        Object.defineProperty(ctrl, 'data', { get: getData, set: setData });

        // Methods
        ctrl.$onInit = init;
        ctrl.showMemberLookupModal = showMemberLookupModal;
        ctrl.clearMember = clearMember;
        ctrl.refresh = refresh;

        ///////////////////////////////////////////////////////
        // Interface
        ///////////////////////////////////////////////////////
        function init() {
            var data = ctrl.data;
            ctrl.individualId = data.individualId;
            ctrl.facility = data.facility;
            ctrl.handicapPercent = data.handicapPercent;
            $scope.$watchGroup(['$ctrl.individualId', '$ctrl.facility'], individualAndFacilityWatchAction);
        }
        function showMemberLookupModal() {
            memberLookupModal().result.then(setIndividualId, noop);
            function setIndividualId(member) {
                ctrl.individualId = member.individualId;
                if (!ctrl.data.facility) {
                    ctrl.data.name = member.name;
                }
            }
        }
        function clearMember(e) {
            ctrl.individualId = null;
            e.stopImmediatePropagation();
        }

        ///////////////////////////////////////////////////////
        // Helpers
        ///////////////////////////////////////////////////////
        function refresh() {
            var facility = ctrl.facility,
                individualId = ctrl.individualId,
                handicapPercent = ctrl.data.handicapPercent,
                facilityId = facility && facility.id;

            Course.getCourseHandicapInfo({ individualId: individualId, facilityId: facilityId, handicapPercent: handicapPercent }, success, error, true);

            function success(data) {
                ctrl.data = data;
            }

            function error(response) {
                alert.error(resources.courseHandicapRequestFailed);
            }
        }
        function individualAndFacilityWatchAction(newVal, oldVal) {
            var individualId = newVal[0], individualIdChanged = individualId !== oldVal[0],
                facility = newVal[1], facilityChanged = facility !== oldVal[1];
            
            // This is optimized to only refresh when we have to.  If we can manually set the data without calling the server,
            // then do so; otherwise, refresh.
            if (individualIdChanged || facilityChanged) {
                if (facility && (facilityChanged || (individualIdChanged && individualId)))
                    refresh();
                else
                    clearData();
            }

            function clearData() {
                if (!facility)
                    ctrl.data.facility = null;
                if (!individualId)
                    clearMemberData();
            }

            function clearMemberData() {
                var
                    facility = ctrl.data.facility,
                    courses = facility && facility.courses || [];

                ctrl.data.name = ctrl.data.individualId = null;
                forEach(courses, function (course) {
                    forEach(course.tees, function (tee) {
                        tee.handicap = tee.maxEsc = tee.targetScore = null;
                    });
                });
            }
        }

        ///////////////////////////////////////////////////////
        // Property Accessors
        ///////////////////////////////////////////////////////
        function getData() {
            return ctrl.model.data;
        }
        function setData(value) {
            ctrl.model.data = value;
        }
    }
})();